<template lang='pug'>
  #article.view
    edit-button( v-if='!mode.edit && user' @click.native='mode.edit = !mode.edit' )
    view-button( v-if='mode.edit && user' @click.native='mode.edit = !mode.edit' )
    save-button( v-if='mode.edit' @click.native='$refs.editor.blur()' )

    template( v-if='user && mode.edit' )
      section
        quill-editor(
          ref='editor'
          :article='article'
          :html.sync='article.html'
          @blur='update( "articles", article )'
        )

    template( v-else )
      section.viewable
        wrapper.max-800.left
          h1.title {{ article.title }}
          p.desc {{ article.description }}
        
      divider.section.on-light.card

      section.viewable
        wrapper.max-800.left
          article( v-html='article.html' )
</template>

<script>
  import { db } from '@/main'
  import Divider from '@/components/containers/divider'
  import Administrable from '@/mixins/firebase/administrable'
  import Database from '@/mixins/firebase/database'
  import EditableInput from '@/components/inputs/editable'
  import EditableTextarea from '@/components/textareas/editable'
  import QuillEditor from '@/components/editors/quill'
  import Wrapper from '@/components/containers/wrapper'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrappers/basic'
  import AttachableImagesInput from '@/components/inputs/attachable/images'
  import EditButton from '@/components/buttons/icon-only/edit'
  import ViewButton from '@/components/buttons/icon-only/view'
  import SaveButton from '@/components/buttons/icon-only/save'
  
  
  export default {
    name: 'article.view',

    mixins: [ Administrable, Database ],

    components: {
      EditableInput,
      EditableTextarea,
      QuillEditor,
      Wrapper,
      BaseModal,
      ModalWrapper,
      AttachableImagesInput,
      EditButton,
      SaveButton,
      ViewButton,
      Divider
    },

    props: {

    },

    data() {
      return {
        article: {},  
        modal: { images: false },
        mode: { edit: false },
        images: []
      }
    },

    firestore() {
      return {
        article: db.collection( 'articles' ).doc( this.$route.params.id ),
        images: db.collection( 'articles' ).doc( this.$route.params.id ).collection( 'images' )
      }
    },

    computed: {
      image() {
        return this.images[0] || { src: '/landing00.jpg' }
      }
    },

    meta() {
      return {
        title: this.article.title,
        meta: [
          { name: 'description', content:  this.article.description },
          { name: 'robots', content: 'index,follow' }, 
          { property: 'og:title', content: this.article.title },
          { property: 'og:image', content: this.image.src },
          { property: 'og:description', content: this.article.description },
          { property: 'og:site_name', content: 'DigiNomix.co' },
          { property: 'og:type', content: 'website'}  
        ]
      }
    },

    methods: {
      update() {
        db.collection( 'articles' ).doc( this.article.id ).update( this.article )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #article
    //

  .title
    font-size 3.2em
    margin 32px 0

  button.edit, button.save, button.view
    position fixed
    bottom 1vh
    right 1vw
    font-size 1.75em
    z-index 1
  
  button.save
    bottom 8vh

  article
    position relative
    border-radius 5px
    line-height 1.75
    >>> strong
      font-weight 400
    >>> i, >>> em
      font-style italic
    >>> p
      margin 1em 0
    >>> h1, >>> h2
      margin 3em 0 .5em 0
    >>> h3
      margin-top 3em
      font-size 1.1em
      font-weight 400
    >>> ul, ol
      padding 0
      padding-left 1.75em
      list-style-type circle
      li
        margin 1em 0
        padding-left .25em
    >>> a
      font-style italic
      text-decoration none
      font-weight bold
      color rgb( 0 125 150 ) !important
      cursor pointer

  #article > header
    position relative
    min-height 32vh
    box-shadow 0 0 16px 0 rgba( 0 0 0 .1 )
    .overlay
      position absolute
      height 100%
      width 100%
      display flex
      align-items flex-end
      background linear-gradient(
        180deg,
        rgba( 0 0 0 .2 ),
        rgba( 0 0 0 .6 )
      )
      .wrapper
        width 100%
    img
      position absolute
      height 100%
      width 100%
      object-fit cover
      z-index 0
  section
    .desc
      font-size 1.1em
      margin-top 32px
      line-height 1.6
      font-style italic
  
  .viewable
    padding 4.8vh 4.8vw
</style>
